export enum SearchCategory {
  AIRBNB = 'airbnb',
  JETSTAR = 'jetstar',
  QANTAS = 'qantas',
}
